module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Checks")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [(_vm.properties && _vm.properties.id) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Able to fetch form from JotFom")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [(_vm.hasWebHook) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("WebHook is installed")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("The webhook is how JotForm sends submissions to AppointmentGuru")])], 1), _vm._v(" "), (!_vm.hasWebHook) ? _c('v-list-tile-action', [_c('help-popover', {
    staticClass: "ml-4"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The problem")]), _vm._v("\n        Without the webhook installed, JotForm will not send submissions to AppointmentGuru,\n        and AppointmentGuru will be unable to connect your form submissions to a client in AppointmentGuru."), _c('br'), _vm._v("\n        Normally AppointmentGuru will create the webhook for you automatically when you connect your form.\n        In this case, it appears that something has gone wrong\n\n        "), _c('copy-text-field', {
    attrs: {
      "label": "Your webhook URL",
      "text-to-copy": _vm.webhookUrl
    }
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The solution - manually add your webhook")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Go to your form in jotform")]), _vm._v(" "), _c('li', [_vm._v("Click on settings -> integrations")]), _vm._v(" "), _c('li', [_vm._v("Search for the \"webhook\" integration")]), _vm._v(" "), _c('li', [_vm._v("Paste the URL above and click \"add new webhook\"")]), _vm._v(" "), _c('li', [_vm._v("Click complete integration")])]), _vm._v("\n\n        Return to AppointmentGuru and click the validate form button below\n\n        "), _c('p', [_vm._v("Not comfortable doing it yourself? Send an email to support@appointmentguru.co and we can help you")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [(_vm.hasRelationshipId) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.hasRelationshipId) ? _c('v-list-tile-title', [_vm._v("Form has relationship_id")]) : _c('v-list-tile-title', [_vm._v("Form is missing a relationship_id field")]), _vm._v(" "), (!_vm.hasRelationshipId) ? _c('v-list-tile-sub-title', {
    staticClass: "error--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("warning")]), _vm._v("\n        Without this your data cannot be linked to a client's profile in AppointmentGuru\n      ")], 1) : _c('v-list-tile-sub-title', [_vm._v("This is how AppointmentGuru knows which client to connect the form submission to")])], 1), _vm._v(" "), (!_vm.hasRelationshipId) ? _c('v-list-tile-action', [_c('help-popover', {
    staticClass: "ml-4"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The problem")]), _vm._v("\n        In order for this form submission to be able to be linked to the client,\n        you need a relationship_id on your form.\n\n        "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The solution")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Go to your form in jotform")]), _vm._v(" "), _c('li', [_vm._v("Drag a \"short text\" field onto the form and name it relationship_id")]), _vm._v(" "), _c('li', [_vm._v("Click on properties -> advanced: turn on \"hide field\"")]), _vm._v(" "), _c('li', [_vm._v("Click on properties -> advanced: expand \"field details\" for unique_name, write: relationship_id")]), _vm._v(" "), _c('li', [_vm._v("Come back to this page and click on the \"revalidate\" button (bottom right) to check if you got it right")])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.properties && _vm.properties.activeRedirect === 'thankurl') ? [(_vm.properties && _vm.properties.isEUForm === '1') ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("autorenew")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Form redirects:\n          "), _c('a', {
    attrs: {
      "href": _vm.properties.thankurl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.properties.thankurl) + "\n            "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)]), _vm._v(" "), (!_vm.isValidRedirectUrl(_vm.properties)) ? _c('v-list-tile-sub-title', {
    staticClass: "error--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("warning")]), _vm._v("\n          You are not passing relationship_id to the next form\n        ")], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isValidRedirectUrl(_vm.properties)) ? _c('v-list-tile-action', [_c('help-popover', {
    staticClass: "ml-4"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The problem")]), _vm._v("\n          If you are redirecting this form to another JotForm, you need to pass the relationship_id to the new form\n          so that when the client submits that form it can be linked to their profile\n\n          "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("The solution")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Go to your form in jotform")]), _vm._v(" "), _c('li', [_vm._v("Click on settings -> thank you page")]), _vm._v(" "), _c('li', [_vm._v("Where it says \"enter url\" you need to append "), _c('code', [_vm._v("?relationship_id={relationship_id}")]), _vm._v(" to the end of the URL")])]), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Your redirect url should look something like this:")]), _vm._v(" "), _c('copy-text-field', {
    attrs: {
      "text-to-copy": ((_vm.properties.thankurl) + "?relationship_id={relationship_id}")
    }
  }), _vm._v("\n\n          When you're done, come back here and click the revalidate form botton to check if you fixed it\n        ")], 1)], 1) : _vm._e()], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.properties && _vm.properties.isEUForm === '1') ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("euro")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Form is stored in the EU")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ced9761","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/FormChecks.vue
// module id = 1666
// module chunks = 0